import { useEffect, useMemo, useState } from "react";

import { useGlobalNewOpportunityModalContext } from "../context";
import { useGlobalCreateOpportunityStore } from "../store";
import { DDRendererItem } from "../types";

export const useMultiSelect = (propertyName: string) => {
  const [openSelect, setOpenSelect] = useState(false);
  const { form } = useGlobalNewOpportunityModalContext();
  const { selectTypeAttributes, setMultiSelectActiveAttributes } =
    useGlobalCreateOpportunityStore();

  // Helper function to ensure value is always an array
  const ensureArray = (value: any) => {
    if (!value) return [];
    return Array.isArray(value) ? value : [value];
  };

  useEffect(() => {
    if (form) {
      const currentValue = form.getFieldValue(propertyName);
      const normalizedValue = ensureArray(currentValue);

      if (currentValue !== normalizedValue) {
        form.setFieldValue(propertyName, normalizedValue);
      }
    }
  }, [form, propertyName]);

  const attribute = useMemo(() => {
    return selectTypeAttributes.find(
      attr => attr.property_name === propertyName,
    );
  }, [selectTypeAttributes, propertyName]);
  useEffect(() => {
    const isLastOption =
      attribute?.options.filter(at => at.active).length === 0;
    if (isLastOption) {
      setOpenSelect(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attribute?.options]);

  const handleSelect = (e: DDRendererItem) => {
    const currentValue = form?.getFieldValue(attribute?.property_name);
    const normalizedValue = ensureArray(currentValue);

    if (attribute) {
      // Check if value exists in array
      const valueExists = normalizedValue.includes(e.id);

      // Remove if exists, add if doesn't exist
      const newValue = valueExists
        ? normalizedValue.filter(val => val !== e.id)
        : [...normalizedValue, e.id];

      form?.setFieldValue(attribute.property_name, newValue);

      setMultiSelectActiveAttributes({
        property_name: attribute.property_name,
        optionId: String(e.id),
      });
    }
  };

  return { attribute, openSelect, setOpenSelect, handleSelect, ensureArray };
};
